// extracted by mini-css-extract-plugin
export default {"editor-content":"style_editor-content__xd5tz","editor-content-container":"style_editor-content-container__6eC2w"};